export const preferenceLevelOptions = [
  { text: "Proibido", value: 0 },
  { text: "Baixa", value: 1 },
  { text: "Média", value: 5 },
  { text: "Alta", value: 10 }
];

export function clampPreferenceValue(value) {
  const numeric = Number(value);
  if (Number.isNaN(numeric)) {
    return 0;
  }

  if (numeric < 0) {
    return 0;
  }

  if (numeric > 10) {
    return 10;
  }

  return numeric;
}

export function getClosestPreferenceLevelValue(value) {
  const clampedValue = clampPreferenceValue(value);

  if (clampedValue === 0) {
    return 0;
  }

  if (clampedValue > 0 && clampedValue < 1) {
    return 1;
  }

  return preferenceLevelOptions.reduce((closest, option) => {
    const optionDistance = Math.abs(option.value - clampedValue);
    const currentDistance = Math.abs(closest - clampedValue);
    return optionDistance < currentDistance ? option.value : closest;
  }, preferenceLevelOptions[0].value);
}

export function isNoSpecificPreference(preferences) {
  if (!Array.isArray(preferences) || preferences.length === 0) {
    return false;
  }

  const values = preferences.map(e => Number(e.value));

  if (values.some(value => Number.isNaN(value) || value <= 0)) {
    return false;
  }

  return values.every(value => value === values[0]);
}